import { render, staticRenderFns } from "./AlphaList.vue?vue&type=template&id=87a6ca32&scoped=true&"
import script from "./AlphaList.vue?vue&type=script&lang=js&"
export * from "./AlphaList.vue?vue&type=script&lang=js&"
import style0 from "./AlphaList.vue?vue&type=style&index=0&id=87a6ca32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a6ca32",
  null
  
)

component.options.__file = "AlphaList.vue"
export default component.exports